define.alias("@ember/render-modifiers/modifiers/did-insert", "calendar/modifiers/did-insert");